export enum EStorageTarget {
  LOCAL,
  SESSION,
}

abstract class StorageItem {
  constructor(
    private key: string,
    private target: EStorageTarget,
    private value: string | null = null,
  ) {
    // const storedValue = this.getStorage().getItem(this.key);
    // if (storedValue !== null) {
    //   this.value = storedValue;
    // }
  }

  // accessing local/session storage is allowed only in this function
  private getStorage(): Storage {
    switch (this.target) {
      case EStorageTarget.LOCAL:
        return localStorage;

      case EStorageTarget.SESSION:
        return sessionStorage;
    }
  }

  protected getRawValue(): string | null {
    return this.value;
  }

  protected setRawValue(value: string): void {
    if (this.value === value) {
      return;
    }

    this.getStorage().setItem(this.key, value);
    this.value = value;
  }

  public removeItem(): void {
    this.getStorage().removeItem(this.key);
    this.value = null;
  }

  hasValue(): boolean {
    return this.value !== null;
  }
}

export class StringStorageItem extends StorageItem {
  getValue(defaultValue = ""): string {
    const rawValue = this.getRawValue();

    if (typeof rawValue === "string") {
      return rawValue;
    }

    return defaultValue;
  }

  setValue(value: string): void {
    this.setRawValue(value);
  }
}

export class BooleanStorageItem extends StorageItem {
  getValue(defaultValue = false): boolean {
    const rawValue = this.getRawValue();

    if (rawValue && ["1", "0"].includes(rawValue)) {
      return rawValue === "1";
    }

    return defaultValue;
  }

  setValue(value: boolean): void {
    this.setRawValue(value ? "1" : "0");
  }
}

export class JsonStorageItem<T> extends StorageItem {
  getValue(defaultValue: T): T {
    const rawValue = this.getRawValue();

    if (rawValue) {
      try {
        return JSON.parse(rawValue);
      } catch {}
    }

    return defaultValue;
  }

  setValue(value: T): void {
    this.setRawValue(JSON.stringify(value));
  }
}
